var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',_vm._g(_vm._b({attrs:{"vertical":!_vm.$store.getters.is_mobile}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("tabs"),_vm._t("items")],2)}
var staticRenderFns = []

export { render, staticRenderFns }